import ListMap from '../core/ListMap';
import MetaOperator from './MetaOperator';

class MetaOperatorList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({ ...args, data: data.map(v => new MetaOperator({ ...args, data: v })) });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaOperator({ data: { id: key } });
  }

  // merge(otherList) {
  //   return this._mergeWithReplace(otherList);
  // }
}

export default MetaOperatorList;
